const initialBoard = {
  payload: {},
}

const loginReducer = (state = initialBoard, action) => {
  switch (action.type) {
    case 'CHANGE_LOGIN_DETAILS':
      return {
        ...state,
        payload: action.payload,
      }
    default:
      return { ...state }
  }
}

export default loginReducer
